// @ts-nocheck
import { useState, useEffect, useContext, useCallback } from 'react';
import Util from 'lib/util';
import Http from 'services/http2';
import CompanyService from 'services/company2';
import EnumService from 'services/enum2';
import ModalService from 'services/modal';
import { ActionContext } from 'actions/context';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { TextField, Button } from '@material-ui/core';
import { useForm, Controller, useController } from 'react-hook-form';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import dayjs from 'dayjs';
/**
 * 添加物料公共弹窗组件
 */
function DialogAddProd(props) {
  const { state, dispatch } = useContext(ActionContext);
  const { open, onComplete, onClose, companyCode } = props;
  const [categoryTypeList, setCategoryTypeList] = useState([]); // 物料分类类型列表
  const [categoryType, setCategoryType] = useState(''); // 物料分类类型
  const [categoryCodeList, setCategoryCodeList] = useState([]); // 物料分类编码参数
  const [categoryList, setCategoryList] = useState([]); // 物料分类列表
  const [list, setList] = useState([]); // 列表
  const [pageNum, setPageNum] = useState(1); // 页码
  const [totalNum, setTotalNum] = useState(0); // 总数
  const [totalPage, setTotalPage] = useState(0); // 总页数
  const [searchKey, setSearchKey] = useState(''); // 搜索关键字
  const [selectedList, setSelectedList] = useState([]); // 已选择列表

  const [isInit, setIsInit] = useState(false);
  const { control, handleSubmit } = useForm({
    mode: 'onChange',
    shouldFocusError: true
  });

  // type="inquiry"
  // [orgCompanyCode]="detail.purCompanyCode"
  // (afterComplete)="handleProdChange($event)"

  useEffect(() => {
    // 初始化物料分类
    async function initCategoryList() {
      let arr = await EnumService.getItems('B02_Material_Category_Type');
      setCategoryTypeList(arr);
      setIsInit(true);
    }

    if (open && !isInit) {
      initCategoryList();
    }
  }, [open, isInit]);

  // 弹窗时搜索
  useEffect(() => {
    if (open) {
      clear();
      search();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  /** 物料分类 begin */

  // 物料分类类型改变
  function handleCateTypeChange(event) {
    let value = event.target.value;
    setCategoryType(value);
    CompanyService.getCustomizeCategory(companyCode, [value]).then(arr => {
      setCategoryList(arr);
      setCategoryCodeList([]);
    });
  }

  // 物料分类改变
  function handleCateChange(event) {
    let value = event.target.value;
    setList([]);
    setPageNum(1);
    setCategoryCodeList([value]);
    search([value]);
  }

  function clear() {
    setCategoryType(undefined);
    setCategoryCodeList([]);
    setCategoryList([]);
    setSelectedList([]);
    setPageNum(1);
    setTotalNum(0);
    setTotalPage(0);
    setList([]);
    setSearchKey(undefined);
  }

  /** 物料分类 end */

  // 获取列表
  async function search(arrCode?, isMore?, key?) {
    let codeList = arrCode || categoryCodeList;
    let n = pageNum;
    if (isMore) {
      n = pageNum + 1;
      setPageNum(n);
    }
    let postbody = {
      apiPath: '/archives/compProd/getSimplePageList',
      companyCode,
      categoryCodeList: codeList,
      categoryType,
      pageNum: n,
      pageSize: 10,
      searchKey: key
    };
    ModalService.showLoading(dispatch);
    await Http.post<UserResponse>('/api/cloudCenter', postbody).then(
      response => {
        ModalService.hideLoading(dispatch);
        if (response.success) {
          setTotalNum(response.data.total);
          setTotalPage(response.data.pages);
          let arr = isMore
            ? list.concat(response.data?.list)
            : response.data?.list || [];
          afterSearch(arr);
          setList(arr);
        }
      }
    );
  }

  // 格式化数据
  function afterSearch(arr) {
    arr.forEach(item => {
      let codeField = 'prodCode';
      //原始已选择项不可编辑
      // item.disabled = this.checkedList.some(
      //   line => line[codeField] === item[codeField]
      // );
      //已选择项
      item.checked = selectedList.some(
        line => line[codeField] === item[codeField]
      );
    });
  }

  // 选择项次
  function handleItemChange(item) {
    item.checked = !item.checked;
    let arr = selectedList.slice(0);
    if (item.checked) {
      arr.push(item);
    } else {
      let idx = arr.findIndex(row => row.prodCode === item.prodCode);
      if (idx !== -1) {
        arr.splice(idx, 1);
      }
    }
    setSelectedList(arr);
  }

  // 删除已选择项
  function deleteItem(i) {
    let arr = selectedList.slice(0);
    let delItem = arr.splice(i, 1);
    let delKey = '';
    delItem.forEach((del, idx) => {
      if (idx === 0) {
        delKey = del.prodCode + del.prodName + del.prodScale;
      }
    });
    list.some(item => {
      let uniKey = item.prodCode + item.prodName + item.prodScale;
      if (delKey === uniKey) {
        item.checked = false;
      }
      return delKey === uniKey;
    });
    setSelectedList(arr);
    setList(list);
  }

  /**
   * 获取枚举字段name
   *
   * @param code
   * @param list
   * @param [nameField] name字段，默认为 'text'
   * @returns
   */
  // function getNameByCode(code, list, nameField = 'text') {
  //   for (let item of list) {
  //     if (code === item.id) {
  //       return item[nameField];
  //     }
  //   }
  //   return '';
  // }

  // 确认
  function ok() {
    if (typeof onComplete === 'function') {
      onComplete(selectedList);
    }
    close();
  }

  // 校验
  function validate(formData) {
    let { reqQty } = formData;
    if (!/^\d+$/.test(reqQty)) {
      return false;
    }
    return true;
  }

  // 关闭
  function close() {
    if (typeof onClose === 'function') {
      onClose();
    }
  }

  // 搜索
  function handleSearchChange(event) {
    //回车
    if (event.keyCode === 13) {
      let value = event.target.value;
      search(undefined, false, value);
    }
  }

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <div className="m-search-box">
        <input
          type="search"
          placeholder="物料编码/名称/规格"
          value={searchKey || ''}
          onChange={e => {
            setSearchKey(e.target.value);
          }}
          onKeyDown={e => {
            handleSearchChange(e);
          }}
        />

        {!searchKey && <i className="icon-search"></i>}
        {searchKey && (
          <i
            className="icon-error-fill"
            onClick={() => {
              setSearchKey('');
              search(undefined, false, '');
            }}
          ></i>
        )}
      </div>

      {/* <DialogTitle id="form-dialog-title">新建送货</DialogTitle> */}
      <DialogContent className="mui-dialog-content">
        <form className="add-product" onSubmit={handleSubmit(ok)}>
          {selectedList?.length > 0 && (
            <div className="form-item">
              <p className="form-item-name">已选择物料</p>
              <ul className="selected">
                {selectedList.map((item, i) => (
                  <li className="selected-item" key={i}>
                    <span>
                      {item.prodCode}, {item.prodName}, {item.prodScale}
                    </span>
                    <i
                      className="icon-close"
                      onClick={() => {
                        deleteItem(i);
                      }}
                    ></i>
                  </li>
                ))}
              </ul>
            </div>
          )}
          <div className="form-item">
            <p className="form-item-name">物料分类</p>
            <div className="multi-select-box">
              <Controller
                name="categoryType"
                control={control}
                render={({ field }) => (
                  <select onChange={e => handleCateTypeChange(e)}>
                    <option key="-1" value="">
                      请选择
                    </option>
                    {categoryTypeList.map((row, j) => (
                      <option key={j} value={row.id}>
                        {row.text}
                      </option>
                    ))}
                  </select>
                )}
              />
              <Controller
                name="categoryList"
                control={control}
                value={categoryCodeList[0]}
                render={({ field }) => (
                  <select onChange={e => handleCateChange(e)}>
                    <option key="-1" value={undefined}>
                      请选择{categoryCodeList[0]}
                    </option>
                    {categoryList.map((row, j) => (
                      <option key={j} value={row.id}>
                        {row.text}
                      </option>
                    ))}
                  </select>
                )}
              />
            </div>
          </div>
          <div className="form-item">
            <p className="form-item-name">物料列表</p>
            <ul className="product-list">
              {list?.map((item, i) => (
                <li className="product-item" key={i}>
                  <label>
                    <input
                      type="checkbox"
                      checked={item.checked}
                      onChange={() => {
                        handleItemChange(item);
                      }}
                    />
                    <span>
                      {item.prodCode}, {item.prodName}, {item.prodScale}
                    </span>
                  </label>
                </li>
              ))}
            </ul>
            {list.length > 0 && (
              <div
                className="show-more"
                onClick={() => {
                  search([], true);
                }}
              >
                <span>共{totalNum}条</span>
                {pageNum < totalPage && <i className="icon-open"></i>}
              </div>
            )}
          </div>
        </form>
      </DialogContent>
      <DialogActions className="dialog-sticky-actions">
        <Button onClick={close} variant="contained">
          取消
        </Button>
        <Button
          onClick={ok}
          variant="contained"
          color="primary"
          className="mui-btn-primary"
        >
          确认
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogAddProd;
